<template>
  <!-- Page wrapper: full viewport height, vertical flex -->
  <div v-if="getCurrentUser?.isUserLoggedIn" class="min-h-screen flex flex-col">
    <!-- Top bar -->
    <div class="flex justify-between p-4 top-bar items-center">
      <div>
        <PrimeButton
          v-if="!isSearch && !isNotAuthorized"
          :type="BUTTON_TYPES.Back"
          :showLabel="false"
          @click="openPharmacySearch"
        />
      </div>
      <div class="top-bar-heading">
        {{ isSearch ? "Partner-Portal" : getPharmacy?.name }}
      </div>
      <PrimeButton
        :type="BUTTON_TYPES.Logout"
        :showLabel="false"
        @click="msalService.msalCallReducer(msalService.reducerActions.logout)"
        tooltip="Abmelden"
      />
    </div>

    <!-- Main content grows to fill space, pushing footer down when short -->
    <main class="flex-1 p-6">
      <router-view v-slot="{ Component }">
        <component :is="Component" />
      </router-view>
    </main>

    <!-- Footer: normal flow element (not fixed) -->
    <footer class="flex justify-end p-4 bottom-bar">
      <div class="flex gap-4">
        <a
          class="link"
          href="https://zukunftspakt-apotheke.de/kontakt/"
          target="_blank"
          rel="noopener noreferrer"
          >Kontakt</a
        >
        <a
          class="link"
          href="https://zukunftspakt-apotheke.de/impressum/"
          target="_blank"
          rel="noopener noreferrer"
          >Impressum</a
        >
      </div>
    </footer>
  </div>
</template>

<script setup>
import { computed } from "vue";
import { useRoute } from "vue-router";
import PrimeButton from "@/components/PrimeButton.vue";
import { BUTTON_TYPES } from "@/Constants";
import MsalService from "@/service/MsalService.js";
import { useRouter } from "vue-router";
import { usePharmacyStore } from "@/store/PharmacyStore";
import { storeToRefs } from "pinia";
import { useLoggedInUserStore } from "@/store/LoggedInUserStore";

const pharmacyStore = usePharmacyStore();
const { getPharmacy } = storeToRefs(pharmacyStore);

const loggedInUserStore = useLoggedInUserStore();
const { getCurrentUser } = storeToRefs(loggedInUserStore);

const msalService = new MsalService();

const route = useRoute();
const router = useRouter();

const isSearch = computed(() => route.fullPath.startsWith("/search"));
const isNotAuthorized = computed(() =>
  route.fullPath.startsWith("/not-authorized")
);

const openPharmacySearch = () => {
  router.push({ name: "search" });
};
</script>

<style scoped>
.top-bar {
  background: #f7f5f1;
  border-bottom: 1px solid #dee2e6;
}
.top-bar-heading {
  font-size: 17.5px;
  font-weight: 600;
  text-transform: uppercase;
  display: flex;
  align-items: center;
}

.bottom-bar {
  background: #333;
  color: white;
  text-align: center;
  padding: 1em;
}

.link {
  color: white !important;
  text-decoration: none;
}
.link:hover {
  text-decoration: underline !important;
}
</style>
